<template>
  <div :class="$b()">
    <content-loop
      :rows="rows"
      :class="$b('content')"
    />
  </div>
</template>

<script setup>
import gqlQuery from '~/gql/home.gql'

definePageMeta({
  name: 'Home',
  pageType: 'Home Page'
})

const { $sentry, $product, $head } = useNuxtApp()

const rows = ref([])
const hero = ref({})
const meta = ref({})

const { data: result, error } = await useDatoQuery({
  query: gqlQuery,
})

if (error.value) {
  $sentry.captureException(error.value)
  console.log(error.value)
  throw createError({
    statusCode: error.value.statusCode,
    statusMessage: 'Unable to load homepage',
  })
}

rows.value = result.value.homepage.rows
hero.value = result.value.homepage.hero
meta.value = result.value.homepage.meta

useHead($head(result.value.homepage.meta))

await $product.getFromLandingPageResponse(result.value.homepage)
</script>

<script>
export default defineNuxtComponent({
  name: 'HomePage'
})
</script>

<style lang="postcss">
.HomePage {
  @apply flex flex-col;
}
</style>
